(function () {
  'use strict';

  angular.module('MktzapApp.Controllers')
    .controller('PocsDetailController', pocs);

  pocs.$inject = ['$scope', 'FoundationApi', '$http', '$state'];

  function pocs ($scope, FoundationApi, $http, $state) {
    var vm = this;
    var poc_id = $state.params.id;

    $http.get(apiUrl + '/pocs/' + poc_id)
      .then(function ({ data }) {
        vm.poc = data;
      }, function (error) { console.log(error) });
  }
})();
